import type { TypographyProps } from '@iheartjane/reefer';
import { Typography } from '@iheartjane/reefer';

interface TextWithFontProps extends TypographyProps {
  fontFamily?: string;
}

export const TextWithFont = ({
  children,
  fontFamily,
  ...props
}: TextWithFontProps) => (
  <Typography {...props} style={{ ...props.style, fontFamily }}>
    {children}
  </Typography>
);
